import type { ApiResponse } from '@/types/api'
import type { GrafReference, Reference } from '@/types/entities'
import { apiDelete, apiGet, apiPost, apiPut } from './http'

// API des références scientifiques
export const referencesApi = {
  /**
   * Récupérer toutes les références
   */
  async list(): Promise<ApiResponse<Reference[]>> {
    console.log('[ReferencesAPI] list')
    return apiGet<ApiResponse<Reference[]>>('/references')
  },

  /**
   * Récupérer une référence par ID
   */
  async getById(id: number): Promise<ApiResponse<Reference>> {
    console.log('[ReferencesAPI] getById:', id)
    return apiGet<ApiResponse<Reference>>(`/references/${id}`)
  },

  /**
   * Créer une référence
   */
  async create(data: Partial<Reference>): Promise<ApiResponse<Reference>> {
    console.log('[ReferencesAPI] create:', data)
    return apiPost<ApiResponse<Reference>>('/references', data)
  },

  /**
   * Mettre à jour une référence
   */
  async update(id: number, data: Partial<Reference>): Promise<ApiResponse<Reference>> {
    console.log('[ReferencesAPI] update:', id, data)
    return apiPut<ApiResponse<Reference>>(`/references/${id}`, data)
  },

  /**
   * Supprimer une référence
   */
  async delete(id: number): Promise<void> {
    console.log('[ReferencesAPI] delete:', id)
    return apiDelete<void>(`/references/${id}`)
  },

  /**
   * Récupérer les graffitis associés à une référence
   */
  async getGraffitisByReferenceId(id: number): Promise<ApiResponse<number[]>> {
    console.log('[ReferencesAPI] getGraffitisByReferenceId:', id)
    return apiGet<ApiResponse<number[]>>(`/references/${id}/graffitis`)
  },

  /**
   * Récupérer les références associées à un graffiti
   */
  async getByGraffitiId(
    graffitiId: number,
    includeReference = false
  ): Promise<ApiResponse<GrafReference[]>> {
    console.log(
      '[ReferencesAPI] getByGraffitiId:',
      graffitiId,
      'includeReference:',
      includeReference
    )
    const params = includeReference ? { includeReference: 'true' } : undefined
    try {
      const response = await apiGet<ApiResponse<GrafReference[]>>(
        `/graffitis/${graffitiId}/references`,
        params
      )
      console.log('[ReferencesAPI] Réponse brute:', {
        hasData: !!response.data,
        dataLength: Array.isArray(response.data) ? response.data.length : 'N/A',
        responseKeys: Object.keys(response),
      })
      // S'assurer que la réponse a bien la structure attendue
      if (!response.data) {
        console.warn('[ReferencesAPI] Réponse sans data, utilisation de tableau vide')
        return { data: [] }
      }
      return response
    } catch (error) {
      console.error('[ReferencesAPI] Erreur lors de l appel API:', {
        graffitiId,
        includeReference,
        error: error instanceof Error ? error.message : String(error),
      })
      // Retourner une réponse vide plutôt que de lancer une erreur
      return { data: [] }
    }
  },

  /**
   * Créer une association graffiti-référence
   */
  async createAssociation(
    graffitiId: number,
    data: Partial<GrafReference>
  ): Promise<ApiResponse<GrafReference>> {
    console.log('[ReferencesAPI] createAssociation:', graffitiId, data)
    return apiPost<ApiResponse<GrafReference>>(`/graffitis/${graffitiId}/references`, data)
  },

  /**
   * Mettre à jour une association graffiti-référence
   */
  async updateAssociation(
    graffitiId: number,
    referenceId: number,
    data: Partial<GrafReference>
  ): Promise<ApiResponse<GrafReference>> {
    console.log('[ReferencesAPI] updateAssociation:', graffitiId, referenceId, data)
    return apiPut<ApiResponse<GrafReference>>(
      `/graffitis/${graffitiId}/references/${referenceId}`,
      data
    )
  },

  /**
   * Supprimer une association graffiti-référence
   */
  async deleteAssociation(graffitiId: number, referenceId: number): Promise<void> {
    console.log('[ReferencesAPI] deleteAssociation:', graffitiId, referenceId)
    return apiDelete<void>(`/graffitis/${graffitiId}/references/${referenceId}`)
  },
}
